import { sendWebsocketMessage, socketStore } from '../../../../../../App';
import { getMarketDataRoute } from '../../../marketDataRouting';

export function requestWrapTradePlanCandidates({
  requestId,
  brokerage,
  accountNumber,
}) {
  const route = getMarketDataRoute({
    dataSource: 'LIVE',
    brokerage,
    messageType: 'requestWrapTradePlanCandidates',
  });

  if (!route.valid) {
    return false;
  }

  socketStore.wrapTradePlanStore.beginCandidatesRequest({
    requestId,
    brokerage: route.brokerage,
    accountNumber,
  });

  sendWebsocketMessage({
    messageType: 'requestWrapTradePlanCandidates',
    requestId,
    dataSource: 'LIVE',
    brokerage: route.brokerage,
    accountNumber,
  });

  return true;
}
